import moment from 'moment'
import { Timestamp } from '@/plugins/firebase'

export const CookingWorkshopType = {
  color: '#af2f27',
  label: 'Cooking Workshop',
  value: 'cooking-workshop',
}
export const EventType = {
  color: 'rgb(175 150 117)',
  label: 'Event',
  value: 'event',
}
export const RetreatType = {
  color: '#ECDFC9',
  textColor: 'black',
  label: 'Seasonal Holistic Retreat',
  value: 'retreat',
}
export const PastEventsTypes = {
  color: 'black',
  label: 'Past Events',
}
export const SupperClubType = {
  color: 'teal darken-3',
  label: 'Supperclub',
  value: 'supperclub',
}
const EBooksType = {
  color: '#7fa99b',
  label: 'EBooks',
  value: 'ebooks',
}
const OnlineLearningType = {
  color: '#668ba4',
  // textColor: 'black',
  label: 'Online Learning',
  value: 'online-learning',
}

export const eventTypes = [
  EventType,
  EBooksType,
  OnlineLearningType,
  CookingWorkshopType,
  RetreatType,
  SupperClubType,
]

function toTimestamp(_moment) {
  return Timestamp.fromDate(_moment.toDate())
}

const _events = [
  {
    endAt: moment('2021-05-01 10:30:00.000+00:00'),
    image: {
      url: require('@/assets/images/retreats/spring/spring.jpg?vuetify-preload')
    },
    publishDate: moment('2021-02-19 10:30:00.000+00:00'),
    startAt: moment('2021-03-21 10:30:00.000+00:00'),
    title: 'Spring - Revitalise',
    to: {name: 'retreat-spring'},
    type: 'retreat',
  },
  {
    endAt: moment('2025-12-31 00:00:00.000+00:00'),
    image: {
      url: require('@/assets/images/introduction-to-sourdough.jpg?vuetify-preload')
    },
    hideDate: true,
    publishDate: moment('20200930'),
    startAt: moment('20200930'),
    title: 'Sourdough Masterclass',
    to: {name: 'sourdough-masterclass'},
    type: 'cooking-workshop',
  },
  {
    endAt: moment('2025-12-31 00:00:00.000+00:00'),
    image: {
      url: require('@/assets/images/kimchi.jpg?vuetify-preload')
    },
    hideDate: true,
    publishDate: moment('20200930'),
    startAt: moment('20200930'),
    title: 'The Magic of Fermentation',
    to: {name: 'the-magic-of-fermentation'},
    type: 'cooking-workshop',
  },
  {
    endAt: moment('2020-12-12 16:00:00.000+00:00'),
    image: {
      url: require('@/assets/images/festive.jpg?vuetify-preload')
    },
    publishDate: moment('2020-11-12 16:00:00.000+00:00'),
    startAt: moment('2020-12-12 16:00:00.000+00:00'),
    title: 'Gifts from the Wholesome Kitchen',
    to: {name: 'gifts-from-the-wholesome-kitchen'},
    type: 'event',
  },
  {
    endAt: moment('2020-01-25 19:00:00.000+00:00'),
    image: {
      url: require('@/assets/images/beet-the-january-blues.jpg?vuetify-preload')
    },
    publishDate: moment('2020-01-01 19:00:00.000+00:00'),
    startAt: moment('2020-01-25 19:00:00.000+00:00'),
    title: 'Beet the January Blues',
    to: {name: 'beet-the-january-blues'},
    type: 'supperclub',
  },
  {
    endAt: moment('2019-11-09 19:00:00.000+00:00'),
    image: {
      url: require('@/assets/images/pumpkin-in-trolley.jpg?vuetify-preload')
    },
    publishDate: moment('2019-10-09 19:00:00.000+00:00'),
    startAt: moment('2019-11-09 19:00:00.000+00:00'),
    title: 'A Taste of Autumn',
    to: {name: 'a-taste-of-autumn'},
    type: 'supperclub',
  },
  {
    endAt: moment('2019-09-21 19:00:00.000+01:00'),
    image: {
      url: require('@/assets/images/vignes.jpg?vuetify-preload')
    },
    publishDate: moment('2019-08-21 19:00:00.000+01:00'),
    startAt: moment('2019-09-21 19:00:00.000+01:00'),
    title: 'Last of The Summer Veg',
    to: {name: 'last-of-the-summer-veg'},
    type: 'supperclub',
  },
]

const now = moment()

export const oldEvents = _events
  .map((_event) => {
    const event = {..._event}
    event.endAt = toTimestamp(event.endAt)
    event.startAt = toTimestamp(event.startAt)
    return event
  })

export const publishedEvents = _events
  .filter((_event) => _event.publishDate.isSameOrBefore(now))
  .sort((a, b) => {
    if (a.publishDate.isBefore(b.publishDate)) return 1
    if (a.publishDate.isAfter(b.publishDate)) return -1
    return 0
  })

export const pastEvents = publishedEvents
  .filter((_event) => now.isAfter(_event.endAt))
  .map((_event) => {
    const event = {..._event}
    event.endAt = toTimestamp(event.endAt)
    event.startAt = toTimestamp(event.startAt)
    return event
  })

export const upcomingEvents = publishedEvents
  .filter((_event) => now.isSameOrBefore(_event.endAt))
  .map((_event) => {
    const event = {..._event}
    event.endAt = toTimestamp(event.endAt)
    event.startAt = toTimestamp(event.startAt)
    return event
  })
